import React from 'react';
import './Footer.css'


const Footer = () => {
    const currentYear = new Date().getFullYear()
    return (
        <div className='footer'>
            <p>&copy;{currentYear} Fitness Tracker</p>
            <p class="footerNote">
                Note: Thanks for visiting my portfolio site. There has been more traffic lately from test users. If the posts are gibberish, I have to reseed my data to help with my job search endeavors as recruiters may be looking at this to judge my skills and content. Thanks for understanding!
            </p>
            <p> 
                Developer: 
            <a className="developer" href="https://www.linkedin.com/in/tillywright/" target="_blank" >Tilly Wright</a></p>
        </div>
    )
}

export default Footer;